export default __webpack_public_path__ + "static/media/location.dff941dc.png";